const headerStyles = {
  container: { flexGrow: 1 },
  appBar: { position: "fixed", background: "#FFFFFF", boxShadow: 'none', borderBottom: '1px solid #CCCCCC'},
  p0: { padding: "0!important" },
  imageBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "1.15rem 1.875rem 1.15rem 0.75rem",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    gap: "1rem",
  },
  multiLangBox: {
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  multiLangChip: {
    marginRight: '0.5rem',
  },
  logoContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    maxHeight: "100%",
    padding: 0,
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  logo: {
    display: "block",
    objectFit: "contain",
    maxWidth: "140px",
    maxHeight: "2.5rem",
    flexShrink: 1,
  },
  subLogo: {
    display: "block",
    objectFit: "contain",
    maxWidth: "140px",
    maxHeight: "2.2rem",
    flexShrink: 1,
  },
  actionChip: {
    height: '24px',
    overflow: 'hidden',
    fontSize: '0.75rem',
    '& .MuiChip-label': {
      paddingTop: 0,
      paddingBottom: 0,
      lineHeight: '22px',
      display: 'flex',
      alignItems: 'center',
    },
  },
  cancelIcon :{
    width: '24px',
    height: '24px',
    minWidth: '24px',
    padding: '4px',
    border: '1px solid #CCCCCC',
    backgroundColor: 'transparent',
    marginLeft: 'auto',
    borderRadius: '50%',
  },
  cancelIconFont: { fontSize: '16px', display: 'block' }
}

export default headerStyles;